import { render, staticRenderFns } from "./ViewBan.vue?vue&type=template&id=655e2052&"
import script from "./ViewBan.vue?vue&type=script&lang=js&"
export * from "./ViewBan.vue?vue&type=script&lang=js&"
import style0 from "./ViewBan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports